import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { FUNNEL_BOOKING_ENGINE_RULE_MODULE, BOOKING_ENGINE_RULE_DEFAULT_COLUMNS } from "../constant/funnelBookingEngineRuleConstant";
import { setListPreference, ListPreferenceResult } from "../../utils/list/utils/setListPreference";

export const setFunnelBookingEngineRulePreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: FUNNEL_BOOKING_ENGINE_RULE_MODULE,
        default_columns: BOOKING_ENGINE_RULE_DEFAULT_COLUMNS,
        default_order_by: '-created_date',
    });
